<template>
  <partner-form :partner="newPartner"></partner-form>
</template>

<script>
import PartnerForm from './partnerForm'

export default {
  name: 'NewPartner',
  components: {PartnerForm},
  data () {
    return {
      newPartner: {
        'code': '',
        'name': '',
        'org': null,
        'phone': '',
        'contractEndTime': '',
        'statusCode': '',
        'statusName': '',
        'deleteFlag': '',
        'updateTime': '',
        'vehicleList': '',
        passRules: []
      },
    }
  },
}
</script>

<style scoped>

</style>
